import { __decorate, __metadata } from "tslib";
import { BaseService, HTTP_METHOD, Method, restParamMapper, Service, STATUS, } from '@cbbt/lib-interface';
import { InvalidJwtError } from './error/InvalidJwtError.js';
import { GenerateExternalServiceTokenRequest } from './messages/GenerateExternalServiceTokenRequest.js';
import { TokenResponse } from './messages/TokenResponse.js';
let ExternalTokenService = class ExternalTokenService extends BaseService {
    generateExternalIDVToken(_transport, request) {
        return this.unimplemented(request);
    }
};
__decorate([
    Method({
        summary: 'External JWT generator service of IDV for external services',
        description: 'Generates the access tokens for external services',
        successStatus: STATUS.OK,
        throws: [InvalidJwtError],
    }),
    Method.rest({
        method: HTTP_METHOD.POST,
        path: '/externalToken',
        params: [
            restParamMapper.header({ from: 'x-lbg-jwt', to: 'jwt' }),
            restParamMapper.header({ from: 'x-lbg-brand', to: 'brand' }),
            restParamMapper.header({
                from: 'x-lbg-idv-session-id',
                to: 'sessionId',
            }),
        ],
        body: restParamMapper.json(),
    }),
    Method.grpc(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, GenerateExternalServiceTokenRequest]),
    __metadata("design:returntype", TokenResponse)
], ExternalTokenService.prototype, "generateExternalIDVToken", null);
ExternalTokenService = __decorate([
    Service({
        description: 'This is an external token generation service for IDV',
    })
], ExternalTokenService);
export { ExternalTokenService };
//# sourceMappingURL=ExternalTokenService.js.map